import { SelectProps } from "@tfg/ui"
import { createContext, useContext } from "react"

import {
  FindCertificatesByOrganizationIdQueryParams,
  FindCertificatesByOrganizationIdQueryResponse,
  FindCertificatesByOrganizationIdResponseDto,
} from "~/gen/api"
import { CertificatesListView } from "~/pages/Brand/Certificates/constants"

type CertificatesTableContext = {
  filters: FindCertificatesByOrganizationIdQueryParams
  certificates: FindCertificatesByOrganizationIdQueryResponse
  isLoading: boolean
  isError: boolean
  error: Error | null
  view: CertificatesListView
  globalFilter: string
  checkedCertificates: Set<string>
  selectedCertificateInfo: FindCertificatesByOrganizationIdResponseDto | null
  certificateTypes: SelectProps["data"]
  setCertificateTypes: React.Dispatch<React.SetStateAction<SelectProps["data"]>>
  setCheckedCertificates: React.Dispatch<React.SetStateAction<Set<string>>>
  setSelectedCertificateInfo: React.Dispatch<
    React.SetStateAction<FindCertificatesByOrganizationIdResponseDto | null>
  >
  setGlobalFilter: React.Dispatch<React.SetStateAction<string>>
  setFilters: React.Dispatch<
    React.SetStateAction<FindCertificatesByOrganizationIdQueryParams>
  >
  unsetFilter: (key: keyof FindCertificatesByOrganizationIdQueryParams) => void
}

export const defaultContext: CertificatesTableContext = {
  filters: {},
  certificates: [],
  isLoading: false,
  isError: false,
  error: null,
  view: CertificatesListView.SCOPE,
  globalFilter: "",
  checkedCertificates: new Set(),
  selectedCertificateInfo: null,
  certificateTypes: [],
  setCertificateTypes: () => undefined,
  setCheckedCertificates: () => undefined,
  setSelectedCertificateInfo: () => undefined,
  setGlobalFilter: () => undefined,
  setFilters: () => undefined,
  unsetFilter: () => undefined,
}

export const CertificatesTableContext =
  createContext<CertificatesTableContext>(defaultContext)

export const useCertificatesTableContext = () =>
  useContext(CertificatesTableContext)
